import { data, useLocation, useNavigate, useParams } from "react-router-dom";
import FedaPayButton from "./FedaPayButton"; // Ajustez le chemin selon votre structure
import { Button } from "react-bootstrap";
import { FaPlus, FaEdit, FaMinus, FaEye, FaShareAlt, FaWhatsapp, FaFacebook, FaFacebookMessenger, FaArrowLeft } from "react-icons/fa";
import React, { useState, useEffect } from "react";
import Navbar from "../dashboard/navbar";
import Sidebar from "../dashboard/sidebar";
import useAuth from "../dashboard/useAuth";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { ImBoxAdd } from "react-icons/im";
import { Modal } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { QRCodeCanvas } from 'qrcode.react';


const Detail_produit = ({ titre }) => {
  // useAuth();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);
  const [produit, setProduit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  // const { id } = useParams();
  const { slug } = useParams();

  const user_id = localStorage.getItem("IDDDD");
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [showShareModal, setShowShareModal] = useState(false);
  const [qrCodeData, setQrCodeData] = useState("");
  const [shareSlug, setShareSlug] = useState(slug || "");
  const [activeSubscriptions, setActiveSubscriptions] = useState([]);
  const [tailleStandard, setTailleStandard] = useState('M'); // Valeur par défaut
  const taillesDisponibles = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'Sur mesure'];
  const [avecAvance, setAvecAvance] = useState('non'); // Valeur par défaut 'non'
  const [modePaiement, setModePaiement] = useState('momo'); // Valeur par défaut 'momo'
  const [phone, setPhone] = useState('');
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [email, setEmail] = useState('');
  const [numeroRequired, setNumeroRequired] = useState(false);
  const isPhoneValid = () => {
    // Le numéro doit contenir au moins 8 chiffres (sans compter le code pays)
    return phone && phone.replace(/\D/g, '').length >= 13;
  };
  const isFormValid = () => {
  if (produit.est_mensurable) {
    return isPhoneValid() && 
           nom.trim() !== '' && 
           prenom.trim() !== '' && 
           email.trim() !== '' && 
           /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
  return true;
};

  useEffect(() => {
    document.title = "PayMe | Détail Produit";

    const fetchCategories = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_HOTE + "/liste-categorie/"
        );
        if (response.ok) {
          const data = await response.json();
          // Transformez les IDs en string pour être cohérent
          const formattedCategories = data.map((cat) => ({
            ...cat,
            id: cat.id.toString(),
          }));
          setCategories([{ id: "all", nom: "Tous" }, ...formattedCategories]);
        }
      } catch (error) {
        console.error("Erreur réseau:", error);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    if (user_id) {
      const fetchActiveSubscriptions = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_HOTE}/get-abonnements-actifs/${user_id}/`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          if (response.data.status === "success") {
            console.log("abonnements actifs:", response.data.data);
            setActiveSubscriptions(response.data.data); // Stocker les abonnements actifs
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des abonnements actifs:", error);
        }
      };

      fetchActiveSubscriptions();
    }
  }, [user_id]);

  // Dans Detail_produit.js
  // useEffect(() => {
  //   const verifyPayment = async (transactionId) => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_HOTE}/api/verify-payment/${transactionId}/`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           },
  //         }
  //       );

  //       if (response.data.status === 'approved') {
  //         navigate("/payment-success", {
  //           state: {
  //             transaction: response.data,
  //             product: produit,
  //             quantity: quantity
  //           }
  //         });
  //       } else {
  //         navigate("/payment-failed", {
  //           state: { error: response.data.message || "Paiement échoué" }
  //         });
  //       }
  //     } catch (error) {
  //       navigate("/payment-failed", {
  //         state: { error: error.response?.data?.message || "Erreur de vérification" }
  //       });
  //     }
  //   };

  //   const urlParams = new URLSearchParams(window.location.search);
  //   const transactionId = urlParams.get('transaction_id');

  //   if (transactionId) {
  //     verifyPayment(transactionId);
  //   }
  // }, [navigate, produit, quantity]);



  useEffect(() => {
    // 1. Vérifier le state
    if (state?.produit) {
      setProduit(state.produit);
      console.log("Produit from state:", state.produit);
      console.log("Est mensurable:", state.produit.est_mensurable);
      setLoading(false);
      return;
    }

    // 2. Si pas dans le state mais il y a un ID dans l'URL
    if (slug) {
      const fetchProduit = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_HOTE}/produit-slug/${slug}/`
          );
          setProduit(response.data);
          console.log("Produit from API:", response.data);
          console.log("Est mensurable:", response.data.est_mensurable);
        } catch (error) {
          console.error("Erreur:", error);
          navigate("/produits", { replace: true });
        } finally {
          setLoading(false);
        }
      };

      fetchProduit();
      return;
    }

    // 3. Si aucune des options ci-dessus
    navigate("/produits", { replace: true });
  }, [state, navigate, slug]); // Ajoutez id aux dépendances

  // Vérifier si un abonnement est actif pour ce produit et ce type
  const hasActiveSubscription = (subscriptionType) => {
    if (!produit || !produit.id) return false;
    const productId = parseInt(produit.id); // Convertir en entier
    console.log(`Vérification abonnement ${subscriptionType} pour produit ID: ${productId}`);
    const isActive = activeSubscriptions.some(
      (sub) => sub.id === productId && sub.subscription_type === subscriptionType
    );
    console.log(`Abonnement ${subscriptionType} actif: ${isActive}`);
    return isActive;
  };

  const [accesGroupe, setAccesGroupe] = useState([]);
  const [groupeId, setGroupeId] = useState(null);
  const groupe = localStorage.getItem("groupe");

  const verifGroupe = async () => {
    const groupeStored = localStorage.getItem("groupe");
    const accesGroupeStored = localStorage.getItem("accesGroupe");

    if (groupeStored && accesGroupeStored) {
      setGroupeId(groupeStored);
      setAccesGroupe(JSON.parse(accesGroupeStored));
    } else {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`
        );
        if (response.status === 200) {
          const data = response.data;
          setGroupeId(data.groupe);

          let cleanedAccessArray = [];
          if (Array.isArray(data.acces)) {
            cleanedAccessArray = data.acces
              .map((item) =>
                item.acces
                  ? item.acces
                    .replace(/[\[\]']/g, "")
                    .trim()
                    .split(",")
                    .map((access) => access.trim())
                  : []
              )
              .flat();

            setAccesGroupe(cleanedAccessArray);
          }

          localStorage.setItem("groupe", data.groupe);
          localStorage.setItem(
            "accesGroupe",
            JSON.stringify(cleanedAccessArray)
          );
        }
      } catch (error) {
        console.error("Erreur lors de la vérification du groupe", error);
      }
    }
  };

  useEffect(() => {
    // Initialiser avec "22901" seulement si le pays est Bénin (229)
    if (phone === "" || phone === "229") {
      setPhone("22901");
    }
  }, []); // Exécuté une seule fois au montage du composant

  const handlePhoneChange = (value, country) => {
    // Si le pays est Bénin (229)
    if (country.dialCode === "229") {
      // Garde toujours "22901" comme base
      const baseNumber = "22901";

      // Si l'utilisateur essaie de supprimer des chiffres après "22901"
      if (value.startsWith(baseNumber)) {
        setPhone(value);
      } else {
        // Si l'utilisateur a supprimé une partie, réinsère "22901"
        // Et ajoute les chiffres supplémentaires s'il y en a
        const extraDigits = value.replace(/\D/g, '').replace(/^229/, '');
        setPhone(baseNumber + extraDigits);
      }
    } else {
      // Pour les autres pays, juste le code pays
      setPhone(country.dialCode);
    }
  };


  const calculateTotal = () => {
    return (produit.prix * quantity).toLocaleString();
  };

  // Fonction pour déterminer si c'est un paiement unique
  const isPaiementUnique = () => {
    return produit.type_paiement === 'unique';
  };

  // Fonction pour déterminer si c'est un abonnement
  const isAbonnement = () => {
    return produit.type_paiement === 'abonnement';
  };


  useEffect(() => {
    if (user_id) {
      verifGroupe();
    }
  }, [user_id]);


  useEffect(() => {
    // Scroll vers le haut de la page au chargement
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (!produit) {
    return (
      <div className="alert alert-warning">
        Produit non trouvé. <button onClick={() => navigate(-1)}>Retour</button>
      </div>
    );
  }





  const handleShareClick = async () => {
    try {
      // Récupérer le QR code depuis le backend
      const response = await axios.get(
        `${process.env.REACT_APP_HOTE}/produit-info/${produit.id}/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const newShareSlug = response.data.slug || slug;
      console.log("Voici le slug:", newShareSlug);
      console.log("QR code data:", response.data);
      console.log("Mensurabilité:", response.data.est_mensurable);

      setShareSlug(newShareSlug); // Stockez le slug dans l'état
      setQrCodeData(response.data.qr_code_url || window.location.href);
      setShowShareModal(true);
    } catch (error) {
      console.error("Erreur lors de la récupération du QR code:", error);
      // Fallback si l'API échoue
      setShareSlug(slug || ""); // Utilisez le slug de l'URL comme fallback
      setQrCodeData(window.location.href);
      setShowShareModal(true);
    }
  };

  const handlePaymentClick = () => {
    // if (!user_id) {
    //   localStorage.setItem('redirectAfterLogin', window.location.pathname);
    //   navigate('/connexion');
    //   return false; // Empêche l'action par défaut
    // }

    if (produit.est_mensurable && (!phone || phone.length < 8)) {
      setNumeroRequired(true);
      return false;
    }

    return true;
  };

  const calculatePreorderAmount = () => {
    return Math.ceil(produit.prix * quantity / 2); // Arrondi au supérieur pour éviter les fractions
  };

  console.log("Taille standard actuelle:", tailleStandard);



  return (
    <div id="wrapper">
      {user_id && <Sidebar user_id={user_id} titre={titre} />}
      <div id="page-wrapper" className="gray-bg">
        {user_id && <Navbar />}
        {/* Modifier cette partie */}
        {!isMobile ? (
          <div className="wrapper fadeInRight animated">
            <div className="container">
              <div className="mt-3">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="ibox product-detail">
                      <div className="ibox-title">
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ width: "100%" }}
                        >
                          <h2 className="m-0">Détails du produit</h2>
                          <button
                            className="btn btn-secondary d-flex align-items-center"
                            onClick={() => navigate(-1)}
                            style={{
                              padding: '0.375rem 0.75rem',
                              borderRadius: '0.25rem',
                              transition: 'all 0.3s ease'
                            }}
                          >
                            <FaArrowLeft className="mr-2" />
                            Retour
                          </button>
                        </div>
                      </div>

                      <div className="ibox-content">
                        <div className="row">
                          {/* Colonne de l'image */}
                          <div className="col-md-5">
                            <div
                              className="product-images"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "400px",
                                backgroundColor: "#f8f8f8",
                                padding: "",
                                border: "1px solid #eee",
                                borderRadius: "10px",
                                position: "relative",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center"
                                }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    overflow: "hidden"
                                  }}
                                >
                                  <img
                                    src={produit.photo_url || "/static/images/default-product.png"}
                                    alt={produit.nom}
                                    style={{
                                      minWidth: "100%",
                                      minHeight: "100%",
                                      objectFit: "cover",
                                      display: "block"
                                    }}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = "/static/images/default-product.png";
                                    }}
                                  />
                                </div>
                              </div>

                              {/* Bouton Partager */}
                              <button
                                onClick={handleShareClick}
                                style={{
                                  position: "absolute",
                                  bottom: "1px",
                                  right: "1px",
                                  backgroundColor: "#456bd8",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "50px",
                                  height: "50px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                                  zIndex: 10
                                }}
                                title="Partager ce produit"
                              >
                                <FaShareAlt size={20} />
                              </button>
                            </div>
                          </div>

                          {/* Colonne des détails */}
                          <div className="col-md-7">
                            <h2 className="font-bold m-b-xs">{produit.nom}</h2>
                            <small className="badge badge-primary">
                              {produit.categorie?.nom || "Non spécifiée"}
                            </small>
                            <hr />

                            <h4>Description du produit</h4>
                            <div
                              className="small text-muted"
                              style={{ textAlign: "justify" }}
                              dangerouslySetInnerHTML={{ __html: produit.description || "Aucune description disponible" }}
                            />


                            {/* <dl className="row m-t-md small">
                            <dt className="col-sm-4">Numéro de paiement</dt>
                            <dd className="col-sm-8">
                              {produit.numero_paiement}
                            </dd>
                          </dl> */}

                            <div className="text-right mt-3"></div>

                            <hr />
                            {/* Afficher le sélecteur de quantité et le total uniquement pour paiement unique */}
                            {isPaiementUnique() && (


                              <>

                                {produit.est_mensurable === true && (
                                  <div className="row mt-3">
                                    <div className="col-md-12">
                                      <div className="form-group">
                                        <h5 className="mb-3">Choisissez votre taille</h5>
                                        <div className="d-flex flex-wrap gap-2">
                                          {taillesDisponibles.map((taille) => (
                                            <button
                                              key={taille}
                                              type="button"
                                              className={`btn mr-4 ${tailleStandard === taille ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                              style={{
                                                backgroundColor: tailleStandard === taille ? '#10367D' : 'transparent',
                                                color: tailleStandard === taille ? '#fff' : '#10367D',
                                                border: '1px solid #10367D',
                                                fontSize: '0.75rem',
                                                padding: '4px 8px',
                                              }}
                                              onClick={() => setTailleStandard(taille)}
                                            >
                                              {taille}
                                            </button>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <div className="row mt-3">
                                  <div className="col-md-12">
                                    <div className="form-group">
                                      <h5 className="mb-3">Avance</h5>
                                      <div className="d-flex flex-wrap gap-2">
                                        {['oui', 'non'].map((option) => (
                                          <button
                                            key={option}
                                            type="button"
                                            className={`btn mr-4 ${avecAvance === option ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                            style={{
                                              backgroundColor: avecAvance === option ? '#10367D' : 'transparent',
                                              color: avecAvance === option ? '#fff' : '#10367D',
                                              border: '1px solid #10367D',
                                              fontSize: '0.75rem',
                                              padding: '4px 8px',
                                            }}
                                            onClick={() => setAvecAvance(option)}
                                          >
                                            {option === 'oui' ? 'Oui' : 'Non'}
                                          </button>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Section Mode de paiement */}
                                <div className="row mt-3">
                                  <div className="col-md-12">
                                    <div className="form-group">
                                      <h5 className="mb-3">Mode de paiement</h5>
                                      <div className="d-flex flex-wrap gap-2">
                                        {['momo', 'especes'].map((option) => (
                                          <button
                                            key={option}
                                            type="button"
                                            className={`btn mr-4 ${modePaiement === option ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                            style={{
                                              backgroundColor: modePaiement === option ? '#10367D' : 'transparent',
                                              color: modePaiement === option ? '#fff' : '#10367D',
                                              border: '1px solid #10367D',
                                              fontSize: '0.75rem',
                                              padding: '4px 8px',
                                            }}
                                            onClick={() => setModePaiement(option)}
                                          >
                                            {option === 'momo' ? 'Mobile Money' : 'Espèces'}
                                          </button>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>


                                {produit.est_mensurable && (
                                  <>
                                    <div className="row mt-3">
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <h5>Nom*</h5>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={nom}
                                            onChange={(e) => setNom(e.target.value)}
                                            required
                                            placeholder="Votre nom"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <h5>Prénom*</h5>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={prenom}
                                            onChange={(e) => setPrenom(e.target.value)}
                                            required
                                            placeholder="Votre prénom"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col-md-12">
  <div className="form-group">
    <h5>Email*</h5>
    <input
      type="email"
      className="form-control"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      required
      placeholder="Votre email"
    />
    {email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && (
      <small className="text-danger">Veuillez saisir un email valide</small>
    )}
  </div>
</div>
                                    </div>

                                    

                                    <div className="form-group">
                                      <h5>Numéro à contacter*</h5>
                                      <div className="phone-input-wrapper mt-2">
                                        <PhoneInput
                                          country="bj"
                                          value={phone}
                                          onChange={handlePhoneChange}
                                          inputStyle={{
                                            width: "100%",
                                            height: "38px",
                                            border: "none",
                                            padding: "6px 12px",
                                            paddingLeft: "70px",
                                            borderRadius: "0px",
                                          }}
                                          buttonStyle={{
                                            border: "none",
                                            background: "#f0f0f0",
                                            paddingLeft: "3px",
                                            height: "100%",
                                          }}
                                        />
                                      </div>
                                      {produit.est_mensurable && !isPhoneValid() && (
                                        <div className="col-12 mt-2 text-center">
                                          <small className="text-danger">
                                            Veuillez saisir un numéro de téléphone valide pour continuer
                                          </small>
                                        </div>
                                      )}
                                    </div>
                                  </>
                                )}


                                <div className="row align-items-center text-center">
                                  <div className="col-md-4">
                                    <div className="quantity-selector d-flex align-items-center">
                                      <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() =>
                                          setQuantity((prev) => Math.max(1, prev - 1))
                                        }
                                        disabled={quantity <= 1}
                                      >
                                        <FaMinus />
                                      </button>

                                      <span
                                        className="mx-2"
                                        style={{
                                          minWidth: "30px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {quantity}
                                      </span>

                                      <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() =>
                                          setQuantity((prev) => prev + 1)
                                        }
                                      >
                                        <FaPlus />
                                      </button>
                                    </div>
                                  </div>
                                  <div className="col-md-4 text-center">
                                    <small className="text-muted">
                                      {produit.prix.toLocaleString()} FCFA × {quantity}
                                    </small>
                                  </div>
                                  <div className="col-md-4 text-end">
                                    <h1
                                      className="product-main-price mb-0 fw-bold "
                                      style={{ fontWeight: "bold", color: "#6c757d" }}
                                    >
                                      {calculateTotal()} FCFA
                                    </h1>
                                  </div>
                                </div>



                                <div className="row mt-5">
                                  <div className="col-md-12 text-right">
                                    {modePaiement === 'momo' ? (
                                      <FedaPayButton
                                        disabled={produit.est_mensurable && !isFormValid()}
                                        product={produit}
                                        quantity={quantity}
                                        phoneNumber={phone}
                                        customerData={{ firstname: prenom, lastname: nom, email: email }}
                                        mensuration={
                                          produit.est_mensurable
                                            ? { type: 'standard', valeur: tailleStandard }
                                            : null
                                        }
                                        isPreorder={avecAvance === 'oui'}
                                        preorderAmount={calculatePreorderAmount()}
                                        onSuccess={(transaction) => {
                                          console.log("Paiement réussi:", transaction);
                                          navigate("/paiement-reussi", {
                                            state: {
                                              transaction,
                                              produit,
                                              quantity,
                                              phoneNumber: phone,
                                              mensuration: {
                                                type: 'standard',
                                                valeur: tailleStandard
                                              },
                                              isPreorder: avecAvance === 'oui',
                                              customer_fullname: `${nom} ${prenom}`,
                                              modePaiement: 'Mobile Money'
                                            },
                                          });
                                        }}
                                        buttonText={
                                          avecAvance === 'oui'
                                            ? `Payer avance (${calculatePreorderAmount().toLocaleString()} FCFA) via Momo`
                                            : `Payer ${(produit.prix * quantity).toLocaleString()} FCFA via Momo`
                                        }
                                      />
                                    ) : (
                                      <button
                                        className="btn btn-success w-100 py-2"
                                        disabled={produit.est_mensurable && !isFormValid()}
                                        onClick={async () => {
                                          try {
                                            // Préparer les données
                                            const transactionData = {
                                              mode_paiement: 'especes',
                                              product_id: produit.id,
                                              quantity: quantity,
                                              amount: produit.prix * quantity,
                                              phone_number: phone,
                                              mensuration: {
                                                type: 'standard',
                                                valeur: tailleStandard
                                              },
                                              is_preorder: avecAvance === 'oui',
                                              preorder_amount: calculatePreorderAmount(),
                                              customer_firstname: prenom,
                                              customer_lastname: nom,
                                              customer_email: email
                                            };

                                            // Envoyer au backend
                                            const response = await axios.post(
                                              `${process.env.REACT_APP_HOTE}/save-transaction/${user_id || 'null'}/`,
                                              transactionData
                                            );

                                            // Si succès, naviguer vers la page de confirmation
                                            if (response.data.status === "success") {
                                              navigate("/paiement-reussi", {
                                                state: {
                                                  modePaiement: 'especes',
                                                  produit,
                                                  quantity,
                                                  phoneNumber: phone,
                                                  mensuration: {
                                                    type: 'standard',
                                                    valeur: tailleStandard
                                                  },
                                                  isPreorder: avecAvance === 'oui',
                                                  preorderAmount: calculatePreorderAmount(),
                                                  totalAmount: produit.prix * quantity,
                                                  customer_fullname: `${nom} ${prenom}`,
                                                  customer_email: email,
                                                  transaction: response.data // Inclure la réponse du serveur
                                                }
                                              });
                                            } else {
                                              alert("Erreur lors de l'enregistrement: " + response.data.message);
                                            }
                                          } catch (error) {
                                            console.error("Erreur:", error);
                                            alert("Une erreur est survenue lors du paiement");
                                          }
                                        }}
                                      >
                                        {avecAvance === 'oui'
                                          ? `Payer avance (${calculatePreorderAmount().toLocaleString()} FCFA) en espèces`
                                          : `Payer ${(produit.prix * quantity).toLocaleString()} FCFA en espèces`}
                                      </button>
                                    )}
                                  </div>
                                </div>

                                {/* Bouton "Payer maintenant" */}
                                {/* <div className="row mt-5">

                                  {produit.est_mensurable && (<div className="col-md-6">
                                    <FedaPayButton
                                      disabled={produit.est_mensurable && !isFormValid()}
                                      product={produit}
                                      quantity={quantity}
                                      phoneNumber={phone}
                                      customerData={{ firstname: prenom, lastname: nom }}
                                      mensuration={
                                        produit.est_mensurable
                                          ? { type: 'standard', valeur: tailleStandard }
                                          : null
                                      }
                                      isPreorder={true} // Indique que c'est une précommande
                                      preorderAmount={calculatePreorderAmount()} // Passe le montant divisé par 2
                                      onSuccess={(transaction) => {
                                        console.log("Précommande réussie:", transaction);
                                        navigate("/paiement-reussi", {
                                          state: {
                                            transaction,
                                            produit,
                                            quantity,
                                            phoneNumber: phone,
                                            mensuration: {
                                              type: 'standard',
                                              valeur: tailleStandard
                                            },
                                            isPreorder: true, // Indique que c'est une précommande
                                            customer_fullname: `${nom} ${prenom}`
                                          },
                                        });
                                      }}
                                      buttonText={`Avance ${calculatePreorderAmount().toLocaleString()} FCFA`}

                                    />
                                  </div>)}


                                  <div className="col-md-6 text-right">
                                    <FedaPayButton
                                      disabled={produit.est_mensurable && !isFormValid()}
                                      product={produit}
                                      quantity={quantity}
                                      phoneNumber={phone} // Ajout du numéro de téléphone
                                      customerData={{ firstname: prenom, lastname: nom }}
                                      mensuration={
                                        produit.est_mensurable
                                          ? { type: 'standard', valeur: tailleStandard }
                                          : null
                                      }
                                      onSuccess={(transaction) => {
                                        console.log("Paiement réussi:", transaction);
                                        navigate("/paiement-reussi", {
                                          state: {
                                            transaction,
                                            produit,
                                            quantity,
                                            phoneNumber: phone, // Ajout du numéro dans le state
                                            mensuration: {
                                              type: 'standard',
                                              valeur: tailleStandard
                                            },
                                            customer_fullname: `${nom} ${prenom}`
                                          },
                                        });
                                      }}

                                    />
                                  </div>

                                </div> */}
                              </>
                            )}

                            {/* Afficher les options d'abonnement uniquement si c'est un abonnement */}
                            {isAbonnement() && (
                              <div className="row justify-content-center mt-2">
                                {/* MENSUEL - Carte avec effet de survol */}
                                <div className="col-lg-6 mb-4 wow zoomIn">
                                  <div className="card pricing-card border-0  h-100 transition-all hover-scale" style={{ borderRadius: "1px" }}>
                                    <div className="card-header bg-gradient-primary text-white  p-0 overflow-hidden">
                                      <h4 className="fw-bold my-3 text-center">Abonnement Mensuel</h4>
                                      <div className="ribbon">Populaire</div>
                                    </div>
                                    <div className="card-body text-center p-4">
                                      <div className="price-tag mb-3">
                                        <span className="amount" style={{ fontSize: "32px" }}>{produit.prix_mensuel.toLocaleString()} </span>
                                        <span className="currency">FCFA</span>
                                        <span className="period">/mois</span>
                                      </div>
                                      <p className="text-muted mb-4">
                                        {hasActiveSubscription("mensuel")
                                          ? "Renouvelez pour prolonger votre abonnement"
                                          : "Parfait pour essayer notre service"}
                                      </p>
                                      <FedaPayButton
                                        product={produit}
                                        quantity={1}
                                        // onBeforePayment={handlePaymentClick}
                                        subscriptionType="mensuel"
                                        onSuccess={(transaction) => {
                                          console.log("Paiement réussi:", transaction);
                                          axios
                                            .get(
                                              `${process.env.REACT_APP_HOTE}/get-abonnements-actifs/${user_id}/`,
                                              {
                                                headers: {
                                                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                                                },
                                              }
                                            )
                                            .then((response) => {
                                              if (response.data.status === "success") {
                                                setActiveSubscriptions(response.data.data);
                                              }
                                            })
                                            .catch((error) => {
                                              console.error("Erreur lors de la mise à jour des abonnements:", error);
                                            });
                                          navigate("/paiement-reussi", {
                                            state: {
                                              transaction,
                                              produit,
                                              quantity: 1,
                                              subscriptionType: "mensuel",
                                              newDateFin: transaction.dates_abonnement?.fin,
                                            },
                                          });
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* ANNUEL - Carte mise en avant */}
                                <div className="col-lg-6 mb-4 wow zoomIn">
                                  <div className="card pricing-card premium border-0 h-100" style={{ borderRadius: "1px" }}>
                                    <div className="card-header bg-gradient-warning text-white  p-0 position-relative overflow-hidden">
                                      <h4 className="fw-bold my-3 text-center">Abonnement Annuel</h4>
                                    </div>
                                    <div className="card-body text-center p-4">
                                      <div className="price-tag mb-3">
                                        <span className="amount" style={{ fontSize: "32px" }}>{produit.prix_annuel.toLocaleString()} </span>
                                        <span className="currency">FCFA</span>
                                        <span className="period">/an</span>
                                      </div>
                                      <p className="text-muted mb-4">
                                        {hasActiveSubscription("annuel")
                                          ? "Renouvelez pour prolonger votre abonnement"
                                          : "Le choix le plus économique"}
                                      </p>
                                      <FedaPayButton
                                        product={produit}
                                        quantity={1}
                                        // onBeforePayment={handlePaymentClick}
                                        subscriptionType="annuel"
                                        onSuccess={(transaction) => {
                                          console.log("Paiement réussi:", transaction);
                                          axios
                                            .get(
                                              `${process.env.REACT_APP_HOTE}/get-abonnements-actifs/${user_id}/`,
                                              {
                                                headers: {
                                                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                                                },
                                              }
                                            )
                                            .then((response) => {
                                              if (response.data.status === "success") {
                                                setActiveSubscriptions(response.data.data);
                                              }
                                            })
                                            .catch((error) => {
                                              console.error("Erreur lors de la mise à jour des abonnements:", error);
                                            });
                                          navigate("/paiement-reussi", {
                                            state: {
                                              transaction,
                                              produit,
                                              quantity: 1,
                                              subscriptionType: "annuel",
                                              newDateFin: transaction.dates_abonnement?.fin,
                                            },
                                          });
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}



                            <style jsx>{`
  .pricing-card {
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
    transition: transform 0.3s, box-shadow 0.3s;
    border: 1px solid rgba(0,0,0,0.05);
  }
  
  .pricing-card:hover {
    box-shadow: 0 15px 35px rgba(0,0,0,0.1);
  }
  
  .hover-scale:hover {
    transform: translateY(-5px);
  }
  
  .premium {
    border: 2px solid #ffc107;
  }
  
  .price-tag {
    position: relative;
    display: inline-block;
  }
  
  .price-tag .currency {
    font-size: 1.5rem;
    vertical-align: top;
    margin-right: 2px;
  }
  
  .price-tag .amount {
    font-size: 3.5rem;
    font-weight: 700;
    line-height: 1;
  }
  
  .price-tag .period {
    font-size: 1rem;
    color: #6c757d;
  }
  
  .ribbon {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #e83e8c;
    color: white;
    padding: 5px 15px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 25px;
    transform: rotate(10deg);
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }
  
  .bg-gradient-primary {
    background: linear-gradient(135deg, #4e73df 0%, #224abe 100%);
  }
  
  .bg-gradient-warning {
    background: linear-gradient(135deg, #f6c23e 0%, #dda20a 100%);
  }
`}</style>


                          </div>
                        </div>
                      </div>

                      <div className="ibox-footer">
                        <span className="float-right">
                          En stock - <i className="fa fa-clock-o"></i>{" "}
                          {new Date().toLocaleDateString()}
                        </span>
                        Livraison dans toute la région.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (

          <div className="mt-3">
            <div className="row">
              <div className="col-lg-12">
                <div className="ibox product-detail">
                  <div className="ibox-title">
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ width: "100%" }}
                    >
                      <h2 className="m-0" style={{ fontSize: "18px" }}>Détails du produit</h2>
                      <button
                        className="btn btn-secondary d-flex align-items-center"
                        onClick={() => navigate(-1)}
                        style={{
                          padding: '0.375rem 0.75rem',
                          borderRadius: '0.25rem',
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <FaArrowLeft className="mr-2" />
                        Retour
                      </button>
                    </div>
                  </div>

                  <div className="ibox-content">
                    <div className="row">
                      {/* Colonne de l'image */}
                      <div className="col-md-5">
                        <div
                          className="product-images"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "400px",
                            backgroundColor: "#f8f8f8",
                            padding: "",
                            border: "1px solid #eee",
                            borderRadius: "10px",
                            position: "relative",
                            overflow: "hidden"
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                overflow: "hidden"
                              }}
                            >
                              <img
                                src={produit.photo_url || "/static/images/default-product.png"}
                                alt={produit.nom}
                                style={{
                                  minWidth: "100%",
                                  minHeight: "100%",
                                  objectFit: "cover",
                                  display: "block"
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "/static/images/default-product.png";
                                }}
                              />
                            </div>
                          </div>

                          {/* Bouton Partager */}
                          <button
                            onClick={handleShareClick}
                            style={{
                              position: "absolute",
                              bottom: "1px",
                              right: "1px",
                              backgroundColor: "#456bd8",
                              color: "white",
                              border: "none",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                              zIndex: 10
                            }}
                            title="Partager ce produit"
                          >
                            <FaShareAlt size={20} />
                          </button>
                        </div>
                      </div>

                      {/* Colonne des détails */}
                      <div className="col-md-7">
                        <div className="d-flex flex-column align-items-center justify-content-center mb-3">
                          <h2 className="font-bold m-b-xs my-3">{produit.nom}</h2>
                          <small className="badge mb-2">
                            {produit.categorie?.nom || "Non spécifiée"}
                          </small>
                          <h3
                            className="product-main-price mb-0 fw-bold "
                            style={{ fontWeight: "bold", color: "#000000" }}
                          >
                            {produit.prix.toLocaleString()} FCFA
                          </h3>
                        </div>
                        <hr />

                        <h4>Description du produit</h4>
                        <div
                          className="small text-muted"
                          style={{ textAlign: "justify" }}
                          dangerouslySetInnerHTML={{ __html: produit.description || "Aucune description disponible" }}
                        />

                        {/* <dl className="row m-t-md small">
                            <dt className="col-sm-4">Numéro de paiement</dt>
                            <dd className="col-sm-8">
                              {produit.numero_paiement}
                            </dd>
                          </dl> */}

                        <div className="text-right mt-3"></div>

                        <hr />
                        {/* Afficher le sélecteur de quantité et le total uniquement pour paiement unique */}
                        {isPaiementUnique() && (
                          <>
                            {produit.est_mensurable === true && (
                              <div className="row mt-3">
                                <div className="col-md-12">
                                  <div className="form-group ">
                                    <h5 className="mb-3 text-center">Choisissez votre taille</h5>
                                    <div
                                      className="d-flex flex-nowrap overflow-auto gap-2 justify-content-between"
                                      style={{
                                        whiteSpace: 'nowrap',
                                        paddingBottom: '10px', // Pour éviter que la barre de défilement ne couvre le contenu
                                        WebkitOverflowScrolling: 'touch' // Pour un défilement fluide sur iOS
                                      }}
                                    >
                                      {taillesDisponibles.map((taille) => (
                                        <button
                                          key={taille}
                                          type="button"
                                          className={`btn btn-sm mr-1 ${tailleStandard === taille ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                          onClick={() => setTailleStandard(taille)}
                                          style={{
                                            backgroundColor: tailleStandard === taille ? '#10367D' : 'transparent',
                                            color: tailleStandard === taille ? '#fff' : '#10367D',
                                            border: '1px solid #10367D',
                                            fontSize: '0.72rem', // Réduit légèrement la taille de police
                                            padding: '3px 7px', // Réduit légèrement le padding
                                            flex: '0 0 auto',
                                            marginRight: '4px' // Réduit l'espace entre les boutons
                                          }}
                                        >
                                          {taille}
                                        </button>
                                      ))}
                                    </div>

                                    <div className="row mt-3">
                                      <div className="col-md-12">
                                        <div className="form-group">
                                          <h5 className="mb-3">Avance</h5>
                                          <div className="d-flex flex-wrap gap-2">
                                            {['oui', 'non'].map((option) => (
                                              <button
                                                key={option}
                                                type="button"
                                                className={`btn mr-4 ${avecAvance === option ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                                style={{
                                                  backgroundColor: avecAvance === option ? '#10367D' : 'transparent',
                                                  color: avecAvance === option ? '#fff' : '#10367D',
                                                  border: '1px solid #10367D',
                                                  fontSize: '0.75rem',
                                                  padding: '4px 8px',
                                                }}
                                                onClick={() => setAvecAvance(option)}
                                              >
                                                {option === 'oui' ? 'Oui' : 'Non'}
                                              </button>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Section Mode de paiement */}
                                    <div className="row mt-3">
                                      <div className="col-md-12">
                                        <div className="form-group">
                                          <h5 className="mb-3">Mode de paiement</h5>
                                          <div className="d-flex flex-wrap gap-2">
                                            {['momo', 'especes'].map((option) => (
                                              <button
                                                key={option}
                                                type="button"
                                                className={`btn mr-4 ${modePaiement === option ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                                style={{
                                                  backgroundColor: modePaiement === option ? '#10367D' : 'transparent',
                                                  color: modePaiement === option ? '#fff' : '#10367D',
                                                  border: '1px solid #10367D',
                                                  fontSize: '0.75rem',
                                                  padding: '4px 8px',
                                                }}
                                                onClick={() => setModePaiement(option)}
                                              >
                                                {option === 'momo' ? 'Mobile Money' : 'Espèces'}
                                              </button>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <style jsx>{`
  /* Style pour le défilement horizontal sur mobile */
  .overflow-auto::-webkit-scrollbar {
    height: 4px;
  }
  .overflow-auto::-webkit-scrollbar-thumb {
    background-color: rgba(0,0,0,0.2);
    border-radius: 4px;
  }
  .overflow-auto::-webkit-scrollbar-track {
    background-color: rgba(0,0,0,0.05);
  }
`}</style>
                              </div>
                            )}

                            <div className="row mt-3">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <h5>Nom*</h5>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={nom}
                                    onChange={(e) => setNom(e.target.value)}
                                    required
                                    placeholder="Votre nom"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <h5>Prénom*</h5>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={prenom}
                                    onChange={(e) => setPrenom(e.target.value)}
                                    required
                                    placeholder="Votre prénom"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
  <div className="form-group">
    <h5>Email*</h5>
    <input
      type="email"
      className="form-control"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      required
      placeholder="Votre email"
    />
    {email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && (
      <small className="text-danger">Veuillez saisir un email valide</small>
    )}
  </div>
</div>
                            </div>

                            <div className="form-group">
                              <h5>Numéro à contacter*</h5>
                              <div className="phone-input-wrapper">
                                <PhoneInput
                                  country="bj"
                                  value={phone}
                                  onChange={handlePhoneChange}
                                  inputStyle={{
                                    width: "100%",
                                    height: "38px",
                                    border: "none",
                                    padding: "6px 12px",
                                    paddingLeft: "70px",
                                    borderRadius: "0px",
                                  }}
                                  buttonStyle={{
                                    border: "none",
                                    background: "#f0f0f0",
                                    paddingLeft: "3px",
                                    height: "100%",
                                  }}
                                />
                              </div>
                              {produit.est_mensurable && !isPhoneValid() && (
                                <div className="col-12 mt-2 text-center">
                                  <small className="text-danger">
                                    Veuillez saisir un numéro de téléphone valide pour continuer
                                  </small>
                                </div>
                              )}
                            </div>


                            <div className="row align-items-center text-center">
                              <div className="col-md-4 d-flex justify-content-center mb-1">
                                <div className="quantity-selector d-flex align-items-center">
                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() =>
                                      setQuantity((prev) => Math.max(1, prev - 1))
                                    }
                                    disabled={quantity <= 1}
                                  >
                                    <FaMinus />
                                  </button>

                                  <span
                                    className="mx-2"
                                    style={{
                                      minWidth: "30px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {quantity}
                                  </span>

                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() =>
                                      setQuantity((prev) => prev + 1)
                                    }
                                  >
                                    <FaPlus />
                                  </button>
                                </div>
                              </div>
                              <div className="col-md-4 text-center">
                                <small className="text-muted">
                                  {produit.prix.toLocaleString()} FCFA × {quantity}
                                </small>
                              </div>
                            </div>

                            <div className="row mt-5">
                              <div className="col-md-12 text-right">
                                {modePaiement === 'momo' ? (
                                  <FedaPayButton
                                    disabled={produit.est_mensurable && !isFormValid()}
                                    product={produit}
                                    quantity={quantity}
                                    phoneNumber={phone}
                                    customerData={{ firstname: prenom, lastname: nom , email: email }}
                                    mensuration={
                                      produit.est_mensurable
                                        ? { type: 'standard', valeur: tailleStandard }
                                        : null
                                    }
                                    isPreorder={avecAvance === 'oui'}
                                    preorderAmount={calculatePreorderAmount()}
                                    onSuccess={(transaction) => {
                                      console.log("Paiement réussi:", transaction);
                                      navigate("/paiement-reussi", {
                                        state: {
                                          transaction,
                                          produit,
                                          quantity,
                                          phoneNumber: phone,
                                          mensuration: {
                                            type: 'standard',
                                            valeur: tailleStandard
                                          },
                                          isPreorder: avecAvance === 'oui',
                                          customer_fullname: `${nom} ${prenom}`,
                                          modePaiement: 'Mobile Money'
                                        },
                                      });
                                    }}
                                    buttonText={
                                      avecAvance === 'oui'
                                        ? `Payer avance (${calculatePreorderAmount().toLocaleString()} FCFA) via Momo`
                                        : `Payer ${(produit.prix * quantity).toLocaleString()} FCFA via Momo`
                                    }
                                  />
                                ) : (
                                  <button
                                    className={`btn ${(produit.est_mensurable && !isFormValid())
                                        ? 'btn-secondary'
                                        : (avecAvance === 'oui' ? 'btn-preorder' : 'btn-wine')
                                      } w-100 py-2`}
                                    disabled={produit.est_mensurable && !isFormValid()}
                                    onClick={async () => {
                                      try {
                                        // Préparer les données
                                        const transactionData = {
                                          mode_paiement: 'especes',
                                          product_id: produit.id,
                                          quantity: quantity,
                                          amount: produit.prix * quantity,
                                          phone_number: phone,
                                          mensuration: {
                                            type: 'standard',
                                            valeur: tailleStandard
                                          },
                                          is_preorder: avecAvance === 'oui',
                                          preorder_amount: calculatePreorderAmount(),
                                          customer_firstname: prenom,
                                          customer_lastname: nom,
                                          customer_email: email
                                        };

                                        // Envoyer au backend
                                        const response = await axios.post(
                                          `${process.env.REACT_APP_HOTE}/save-transaction/${user_id || 'null'}/`,
                                          transactionData
                                        );

                                        // Si succès, naviguer vers la page de confirmation
                                        if (response.data.status === "success") {
                                          navigate("/paiement-reussi", {
                                            state: {
                                              modePaiement: 'especes',
                                              produit,
                                              quantity,
                                              phoneNumber: phone,
                                              mensuration: {
                                                type: 'standard',
                                                valeur: tailleStandard
                                              },
                                              isPreorder: avecAvance === 'oui',
                                              preorderAmount: calculatePreorderAmount(),
                                              totalAmount: produit.prix * quantity,
                                              customer_fullname: `${nom} ${prenom}`,
                                              customer_email: email,
                                              transaction: response.data // Inclure la réponse du serveur
                                            }
                                          });
                                        } else {
                                          alert("Erreur lors de l'enregistrement: " + response.data.message);
                                        }
                                      } catch (error) {
                                        console.error("Erreur:", error);
                                        alert("Une erreur est survenue lors du paiement");
                                      }
                                    }}
                                  >
                                    {avecAvance === 'oui'
                                      ? `Payer avance (${calculatePreorderAmount().toLocaleString()} FCFA) en espèces`
                                      : `Payer ${(produit.prix * quantity).toLocaleString()} FCFA en espèces`}
                                  </button>
                                )}
                              </div>
                            </div>

                            {/* Bouton "Payer maintenant" */}
                            {/* <div className="row mt-4">

                              {produit.est_mensurable && (<div className="col-md-6">
                                <FedaPayButton
                                  disabled={produit.est_mensurable && !isFormValid()}
                                  product={produit}
                                  quantity={quantity}
                                  phoneNumber={phone}
                                  customerData={{ firstname: prenom, lastname: nom }}
                                  mensuration={
                                    produit.est_mensurable
                                      ? { type: 'standard', valeur: tailleStandard }
                                      : null
                                  }
                                  isPreorder={true} // Indique que c'est une précommande
                                  preorderAmount={calculatePreorderAmount()} // Passe le montant divisé par 2
                                  onSuccess={(transaction) => {
                                    console.log("Précommande réussie:", transaction);
                                    navigate("/paiement-reussi", {
                                      state: {
                                        transaction,
                                        produit,
                                        quantity,
                                        phoneNumber: phone,
                                        mensuration: {
                                          type: 'standard',
                                          valeur: tailleStandard
                                        },
                                        isPreorder: true, // Indique que c'est une précommande
                                        customer_fullname: `${nom} ${prenom}`
                                      },
                                    });
                                  }}
                                  buttonText={`Avance ${calculatePreorderAmount().toLocaleString()} FCFA`}
                                />
                              </div>)}

                              <div className="col-md-6 mt-3 text-right">
                                <FedaPayButton
                                  disabled={produit.est_mensurable && !isFormValid()}
                                  product={produit}
                                  quantity={quantity}
                                  phoneNumber={phone} // Ajout du numéro de téléphone
                                  customerData={{ firstname: prenom, lastname: nom }}
                                  mensuration={
                                    produit.est_mensurable
                                      ? { type: 'standard', valeur: tailleStandard }
                                      : null
                                  }
                                  onSuccess={(transaction) => {
                                    console.log("Paiement réussi:", transaction);
                                    navigate("/paiement-reussi", {
                                      state: {
                                        transaction,
                                        produit,
                                        quantity,
                                        phoneNumber: phone, // Ajout du numéro dans le state
                                        mensuration: {
                                          type: 'standard',
                                          valeur: tailleStandard
                                        },
                                        customer_fullname: `${nom} ${prenom}`
                                      },
                                    });
                                  }}
                                />
                              </div>
                            </div> */}
                          </>
                        )}

                        {/* Afficher les options d'abonnement uniquement si c'est un abonnement */}
                        {isAbonnement() && (
                          <div className="row justify-content-center mt-2">
                            {/* MENSUEL - Carte avec effet de survol */}
                            <div className="col-lg-6 mb-4 wow zoomIn">
                              <div className="card pricing-card border-0  h-100 transition-all hover-scale" style={{ borderRadius: "1px" }}>
                                <div className="card-header bg-gradient-primary text-white  p-0 overflow-hidden">
                                  <h4 className="fw-bold my-3 text-center">Abonnement Mensuel</h4>
                                  <div className="ribbon">Populaire</div>
                                </div>
                                <div className="card-body text-center p-4">
                                  <div className="price-tag mb-3">
                                    <span className="amount" style={{ fontSize: "32px" }}>{produit.prix_mensuel.toLocaleString()} </span>
                                    <span className="currency">FCFA</span>
                                    <span className="period">/mois</span>
                                  </div>
                                  <p className="text-muted mb-4">
                                    {hasActiveSubscription("mensuel")
                                      ? "Renouvelez pour prolonger votre abonnement"
                                      : "Parfait pour essayer notre service"}
                                  </p>
                                  <FedaPayButton
                                    product={produit}
                                    quantity={1}
                                    // onBeforePayment={handlePaymentClick}
                                    subscriptionType="mensuel"
                                    onSuccess={(transaction) => {
                                      console.log("Paiement réussi:", transaction);
                                      axios
                                        .get(
                                          `${process.env.REACT_APP_HOTE}/get-abonnements-actifs/${user_id}/`,
                                          {
                                            headers: {
                                              Authorization: `Bearer ${localStorage.getItem("token")}`,
                                            },
                                          }
                                        )
                                        .then((response) => {
                                          if (response.data.status === "success") {
                                            setActiveSubscriptions(response.data.data);
                                          }
                                        })
                                        .catch((error) => {
                                          console.error("Erreur lors de la mise à jour des abonnements:", error);
                                        });
                                      navigate("/paiement-reussi", {
                                        state: {
                                          transaction,
                                          produit,
                                          quantity: 1,
                                          subscriptionType: "mensuel",
                                          newDateFin: transaction.dates_abonnement?.fin,
                                        },
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* ANNUEL - Carte mise en avant */}
                            <div className="col-lg-6 mb-4 wow zoomIn">
                              <div className="card pricing-card premium border-0 h-100" style={{ borderRadius: "1px" }}>
                                <div className="card-header bg-gradient-warning text-white  p-0 position-relative overflow-hidden">
                                  <h4 className="fw-bold my-3 text-center">Abonnement Annuel</h4>
                                </div>
                                <div className="card-body text-center p-4">
                                  <div className="price-tag mb-3">
                                    <span className="amount" style={{ fontSize: "32px" }}>{produit.prix_annuel.toLocaleString()} </span>
                                    <span className="currency">FCFA</span>
                                    <span className="period">/an</span>
                                  </div>
                                  <p className="text-muted mb-4">
                                    {hasActiveSubscription("annuel")
                                      ? "Renouvelez pour prolonger votre abonnement"
                                      : "Le choix le plus économique"}
                                  </p>
                                  <FedaPayButton
                                    product={produit}
                                    quantity={1}
                                    // onBeforePayment={handlePaymentClick}
                                    subscriptionType="annuel"
                                    onSuccess={(transaction) => {
                                      console.log("Paiement réussi:", transaction);
                                      axios
                                        .get(
                                          `${process.env.REACT_APP_HOTE}/get-abonnements-actifs/${user_id}/`,
                                          {
                                            headers: {
                                              Authorization: `Bearer ${localStorage.getItem("token")}`,
                                            },
                                          }
                                        )
                                        .then((response) => {
                                          if (response.data.status === "success") {
                                            setActiveSubscriptions(response.data.data);
                                          }
                                        })
                                        .catch((error) => {
                                          console.error("Erreur lors de la mise à jour des abonnements:", error);
                                        });
                                      navigate("/paiement-reussi", {
                                        state: {
                                          transaction,
                                          produit,
                                          quantity: 1,
                                          subscriptionType: "annuel",
                                          newDateFin: transaction.dates_abonnement?.fin,
                                        },
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        <style jsx>{`
  .pricing-card {
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
    transition: transform 0.3s, box-shadow 0.3s;
    border: 1px solid rgba(0,0,0,0.05);
  }
  
  .pricing-card:hover {
    box-shadow: 0 15px 35px rgba(0,0,0,0.1);
  }
  
  .hover-scale:hover {
    transform: translateY(-5px);
  }
  
  .premium {
    border: 2px solid #ffc107;
  }
  
  .price-tag {
    position: relative;
    display: inline-block;
  }
  
  .price-tag .currency {
    font-size: 1.5rem;
    vertical-align: top;
    margin-right: 2px;
  }
  
  .price-tag .amount {
    font-size: 3.5rem;
    font-weight: 700;
    line-height: 1;
  }
  
  .price-tag .period {
    font-size: 1rem;
    color: #6c757d;
  }
  
  .ribbon {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #e83e8c;
    color: white;
    padding: 5px 15px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 25px;
    transform: rotate(10deg);
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }
  
  .bg-gradient-primary {
    background: linear-gradient(135deg, #4e73df 0%, #224abe 100%);
  }
  
  .bg-gradient-warning {
    background: linear-gradient(135deg, #f6c23e 0%, #dda20a 100%);
  }
`}</style>


                      </div>
                    </div>
                  </div>

                  <div className="ibox-footer">
                    <span className="float-right">
                      En stock - <i className="fa fa-clock-o"></i>{" "}
                      {new Date().toLocaleDateString()}
                    </span>
                    Livraison dans toute la région.
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


        {/* Modal de partage */}
        <Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered>

          <Modal.Body className="text-center mx-0 pb-4 pt-0">
            <div className="mb-4 ml-0 mr-0">
              <p className="text-muted mb-3">
                Scannez le QR code ou partagez via les réseaux sociaux
              </p>
              <div className="bg-light p-3 rounded d-inline-block">
                <img
                  src={qrCodeData}
                  alt="QR Code"
                  style={{ width: '180px', height: '180px' }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ctext x='50%' y='50%' font-size='10' text-anchor='middle' dominant-baseline='middle'%3EQR Code non disponible%3C/text%3E%3C/svg%3E";
                  }}
                />
              </div>
              <p className="text-muted mt-3 small">
                {produit.nom} - {produit.prix.toLocaleString()} FCFA
              </p>
            </div>

            <div className="d-flex justify-content-center gap-4 mt-4">
              {/* Bouton WhatsApp */}
              <a
                href={`https://wa.me/?text=${encodeURIComponent(
                  `Découvrez ce produit en cliquant sur ce lien: ${window.location.origin}/Detail-produit/${shareSlug}`
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: '#25D366',
                  color: 'white',
                  border: 'none',
                  margin: '0 1rem',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                }}
              >
                <FaWhatsapp size={26} />
              </a>

              {/* Bouton Facebook */}
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  `${window.location.origin}/Detail-produit/${shareSlug}`
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: '#1877F2',
                  color: 'white',
                  border: 'none',
                  margin: '0 1rem',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                }}
              >
                <FaFacebook size={26} />
              </a>

              {/* Bouton Messenger */}
              <a
                href={`fb-messenger://share/?link=${encodeURIComponent(
                  `${window.location.origin}/Detail-produit/${shareSlug}`
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '50px',
                  height: '50px',
                  background: 'linear-gradient(135deg, #00B2FF, #A033FF, #FF5280)',
                  color: 'white',
                  border: 'none',
                  margin: '0 1rem',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
                }}
              >
                <FaFacebookMessenger size={26} />
              </a>
            </div>
          </Modal.Body>
        </Modal>
        <div></div>
      </div>
      <style>{`
  .phone-input-wrapper {
    border: 1px solid #ced4da;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .phone-input-wrapper:focus-within {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
  /* Style spécifique pour agrandir le drapeau */
  .flag-dropdown {
    height: 100%;
  }
  .selected-flag {
    height: 100%;
    padding: 0 8px;
  }
  .selected-flag .flag {
    transform: scale(1.4); /* Agrandit le drapeau de 30% */
    margin-right: 5px;
  }
`}</style>
    </div>
  );
};

export default Detail_produit;
